import styled from "styled-components";

export default function YearGroupMembersRegisterAll() {
  return <Container></Container>;
}

const Container = styled.div``;
